import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { JurisdictionTypeEnum } from '@zaoblako/shared/modules/client/enums/jurisdiction-type.enum';
import { JurisdictionTypeEnumI18n } from '@zaoblako/shared/modules/client/i18n/jurisdiction-type-enum.i18n';

@Pipe({
  name: 'jurisdictionType',
  standalone: true
})
export class JurisdictionTypeNamePipe implements PipeTransform {
  public transform(type: JurisdictionTypeEnum): string {
    return JurisdictionTypeEnumI18n[I18nLocalesEnum.RU_RU][type] || '';
  }
}
